import { UnicodeEntity } from '@mews/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { FeatureFlag } from '@mews-commander/enums';
import { getActiveFeatureFlags } from '@mews/framework';
import { AuthenticatorType } from '@mews-commander/data-access';
import { getUnixTimestampFromUtc } from '@mews-commander/utils';
import { getCurrentUser } from '@mews-commander/core';
import {
    getScopeByProfileId,
    privilegesToClassificationMapper,
} from '@mews-commander/legacy-entities/src/ducks/scopes';
import { getChain } from '@mews-commander/legacy-entities/src/ducks/chains';
import { getSubscription } from '@mews-commander/legacy-entities/src/ducks/subscriptions';
import { getEnterprise } from '@mews-commander/legacy-entities/src/ducks/enterprises';

export const setGainsightUser =
    (profileId: string | undefined): CommanderThunkAction =>
    (dispatch, getState, { gainsightService, featureFlagService }) => {
        if (!profileId) return;

        const state = getState();
        const { createdUtc, email, id, firstName, lastName, authenticator } = getCurrentUser();
        // @ts-expect-error $TSFixMeError: Property 'privileges' does not exist on type 'undefined'.
        const { privileges, enterpriseId, languageCode, assignedLearningPath } = getScopeByProfileId(state, {
            profileId,
        });
        const { chainId, subscriptionId, uniqueName } = getEnterprise(state, { enterpriseId });
        const { segment, tier, supportTier } = getSubscription(state, { subscriptionId });
        const { name: chainName } = getChain(state, { chainId });

        const featureFlagsActive = getActiveFeatureFlags({ featureFlagService, featureFlagEnum: FeatureFlag });

        gainsightService.setGlobalContext({
            profileId,
            role: assignedLearningPath,
            classification: privilegesToClassificationMapper(privileges),
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            resolution: `${window.screen.width}${UnicodeEntity.MultiplicationSign}${window.screen.height}`,
            featureFlagsActive,
        });

        gainsightService.setUser({
            id,
            enterpriseId,
            name: uniqueName,

            chainId,
            chainName,

            email: email ?? undefined,
            firstName: firstName ?? undefined,
            lastName,
            signUpDate: getUnixTimestampFromUtc(createdUtc),
            languageCode,
            has2fa: authenticator !== AuthenticatorType.None,

            segment,
            plan: tier,
            supportTier,
        });
    };

export const resetGainsightUser =
    (): CommanderThunkAction =>
    (dispatch, getState, { gainsightService }) => {
        gainsightService.reset();
    };
